import { render } from "./FilterGroupCustomer.vue?vue&type=template&id=71ea0aa6"
import script from "./FilterGroupCustomer.vue?vue&type=script&lang=js"
export * from "./FilterGroupCustomer.vue?vue&type=script&lang=js"
script.render = render

export default script